import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M20 40c6.062 0 11.493-2.697 15.161-6.956H4.839C8.507 37.303 13.939 40 20 40Zm20-20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 1.805.24 3.554.689 5.217h38.622A19.99 19.99 0 0 0 40 20ZM1.59 27.826a19.94 19.94 0 0 0 1.345 2.609h34.13c.509-.832.96-1.703 1.345-2.609H1.59Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M9.165 12.614 5.258 10.89l3.907-1.725 1.725-3.907 1.724 3.907 3.908 1.725-3.908 1.724-1.724 3.908-1.725-3.908Z"
}, null, -1), d = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "m10.89 7.411 1.065 2.414 2.413 1.065-2.413 1.065-1.065 2.413-1.065-2.413-2.413-1.065 2.413-1.065L10.89 7.41Z"
}, null, -1), h = [
  n,
  c,
  s,
  d
];
function i(_, r) {
  return e(), l("svg", o, [...h]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
